module.exports = __webpack_public_path__ + "img/2.bfb929ae.jpg";